import {
    URLAPI,
    MAINTENANCE_SURVEY_PATH,
    MAINTENANCE_SURVEY_CREATE_PATH,
    MAINTENANCE_SURVEY_UPDATE_PATH,
    MAINTENANCE_SURVEY_DETAILS_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_maintenance_survey: {
        data: [],

        status: 0,
        message: {},
    },

    _create_maintenance_survey: {
        data: {},
        status: 0,
        message: {},
    },
    _update_maintenance_survey: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_MAINTENANCE_SURVEY = "GET_ALL_MAINTENANCE_SURVEY";
export const CREATE_MAINTENANCE_SURVEY = "CREATE_MAINTENANCE_SURVEY";
export const UPDATE_MAINTENANCE_SURVEY = "UPDATE_MAINTENANCE_SURVEY";

export const maintenance_survey_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_MAINTENANCE_SURVEY:
            return {
                ...state,
                _get_all_maintenance_survey: action.payload,
            };
        case CREATE_MAINTENANCE_SURVEY:
            return {
                ...state,
                _create_maintenance_survey: action.payload,
            };
        case UPDATE_MAINTENANCE_SURVEY:
            return {
                ...state,
                _update_maintenance_survey: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllMaintenanceSurvey = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${MAINTENANCE_SURVEY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_MAINTENANCE_SURVEY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_MAINTENANCE_SURVEY,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_MAINTENANCE_SURVEY,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemMaintenanceSurvey = async (token, id) => {
    return await axios.get(`${URLAPI}${MAINTENANCE_SURVEY_DETAILS_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

export const createMaintenanceSurvey = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${MAINTENANCE_SURVEY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_MAINTENANCE_SURVEY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateMaintenanceSurvey = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${MAINTENANCE_SURVEY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_MAINTENANCE_SURVEY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_MAINTENANCE_SURVEY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_MAINTENANCE_SURVEY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_maintenance_survey = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
